module.exports = __webpack_public_path__ + "static/media/slider-backgrounde-1024x543.5096b0a3.jpg";